import { Chip } from '@/ui/primitives';
import { STATUS_LABELS, statusTone } from '../labels';

export function StatusChip({ status }: { status: string }) {
  return (
    <Chip tone={statusTone(status)} size="sm">
      {STATUS_LABELS[status] ?? status}
    </Chip>
  );
}
